import emailjs from '@emailjs/browser';

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_NEWSLETTER_TEMPLATE_ID;
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

/**
 * Subscribe an email address to the newsletter.
 * Sends a notification to olajuwonlawal2012@gmail.com via EmailJS.
 *
 * EmailJS template variables used:
 *   {{subscriber_email}}  — the subscriber's email address
 *
 * To swap for a real mailing-list service (Mailchimp, ConvertKit, etc.), replace
 * the emailjs.send() call with the appropriate API call.
 *
 * @param {string} email
 * @returns {Promise<{ success: true }>}
 */
export async function subscribeNewsletter(email) {
  await new Promise((resolve) => setTimeout(resolve, 500));

  await emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    { subscriber_email: email },
    PUBLIC_KEY,
  );

  return { success: true };
}
